<template>
    <div>
        <div class="col-8">
            <div class="container-new-clean info-block center-text" style="margin-top:100px;">
                <i class="ion-android-checkmark-circle" style="font-size: 60px; color: #008ce8; line-height: 0px; margin-right:0px;"></i>
                <h2>Dziękujemy za złożenie zamówienia!</h2>
                <p>Wkrótce otrzymasz mail potwierdzający, wraz z linkiem do płatności online.<br/>W przypadku ewentualnych problemów skontaktuj się z nami: <a href="mailto:callcenter@dts.pl">callcenter@dts.pl</a><br/>Dziękujemy i życzymy miłego dnia!</p>

                <b style="color: #ff3f00;">Link do płatności:</b>
                <div class="ui input">
                    <input type="text" v-model="payuUrl" />
                </div>
            </div>

        </div>

    </div>
</template>
<script>
    export default {
        name: 'finalStep',
        props: ['payuUrl'],
        data () {
            return {}
        }
    }
</script>



// WEBPACK FOOTER //
// FinalStep.vue?27e3f21d